export const PRODUCTS = [
  {
    id: 0,
    name: "Automatic Rusk Production Line",
    category: "Automation",
    image: "/ruskLine.webp",
    alt: "Automatic rusk production line for high-volume industrial bakery manufacturing",
    description:
      "A fully integrated automatic rusk production line designed for continuous, high-volume manufacturing. The system coordinates mixing, moulding, baking, cooling, and slicing stages to deliver uniform rusk quality with minimal manual handling. Built for bakeries scaling from batch production to automated plant operations, it reduces labour dependency while maintaining consistent output, hygiene standards, and repeatable bake profiles across every shift.",
  },
  {
    id: 1,
    name: "Rotary Rack Oven",
    category: "Ovens",
    image: "/1.webp",
    alt: "Large industrial rotary rack oven with stainless steel finish in a commercial bakery",
    description:
      "Industrial rotary rack ovens rotate loaded racks inside a sealed chamber for even heat distribution across every tray. Ideal for bread, buns, cakes, and rusk batches, they maximise capacity per cycle while maintaining uniform browning and moisture control. Heavy-duty insulation, reliable burners or heating elements, and sturdy rack mechanisms make this oven a core workhorse for medium to large bakeries running multiple product types daily.",
  },
  {
    id: 2,
    name: "Swing Tray Oven",
    category: "Ovens",
    image: "/2.webp",
    alt: "Commercial swing tray oven with multiple baking trays inside a professional bakery",
    description:
      "Swing tray ovens use pivoting tray carriers that swing product into and out of the baking chamber, simplifying loading for operators while keeping heat loss low. Suited for bread, biscuits, and specialty items, they offer flexible tray configurations and straightforward operation for plants that need reliable batch baking without the complexity of tunnel systems. Robust construction and accessible controls support long production runs with easy maintenance.",
  },
  {
    id: 3,
    name: "Chain Type Tunnel Oven",
    category: "Ovens",
    image: "/3.webp",
    alt: "Industrial chain type tunnel oven used for continuous baking in large-scale production",
    description:
      "Chain-type tunnel ovens move products continuously through heated zones on a positive-drive chain conveyor, enabling non-stop production for high-throughput bakeries. Temperature zones can be tuned for proofing, baking, and finishing in one pass. This design is well suited for standardized products such as biscuits, rusks, and bread sticks where consistent line speed and repeatable bake times are critical to quality and yield.",
  },
  {
    id: 4,
    name: "Wire Mesh Type Tunnel Oven",
    category: "Ovens",
    image: "/4.webp",
    alt: "Wire mesh tunnel oven conveyor system for industrial bakery production line",
    description:
      "Wire mesh tunnel ovens carry products on an open mesh belt through controlled heat zones, allowing excellent airflow around delicate or irregular items. Commonly used for cookies, crackers, rusks, and thin bakery products, the mesh bed supports even drying and browning. The continuous conveyor layout integrates cleanly with upstream depositors and downstream cooling or packaging equipment for fully automated lines.",
  },
  {
    id: 5,
    name: "Slow Speed Mixer",
    category: "Mixers",
    image: "/5.webp",
    alt: "Industrial slow speed dough mixer with stainless steel bowl in a commercial kitchen",
    description:
      "Slow speed mixers gently develop dough with low shear, preserving gluten structure for breads, buns, and specialty doughs that need controlled hydration. The slower paddle action reduces heat buildup in the bowl, helping maintain dough temperature and fermentation potential. Stainless bowls, heavy-duty gears, and simple controls make this mixer dependable for daily batching in artisan and industrial bakeries alike.",
  },
  {
    id: 6,
    name: "Spiral Mixer",
    category: "Mixers",
    image: "/6.webp",
    alt: "Heavy-duty commercial spiral dough mixer for large-scale bread production",
    description:
      "Spiral mixers use a rotating spiral hook and fixed bowl to knead dough efficiently with minimal oxidation, producing well-developed gluten for bread and pizza bases. Available in capacities from small shop floors to large plant batches, they deliver consistent mix times and uniform dough texture. Overload protection, timer controls, and rugged bowl lifts support demanding production schedules in commercial bakeries.",
  },
  {
    id: 7,
    name: "High Speed Mixer",
    category: "Mixers",
    image: "/7.webp",
    alt: "Industrial high speed commercial mixer with stainless steel construction",
    description:
      "High speed mixers rapidly incorporate ingredients for batters, creams, and doughs where fast cycle times matter. Powerful motors and precision bowl design reduce mixing time per batch, increasing line throughput for biscuit, cake, and confectionery applications. Built with food-grade stainless contact surfaces and safety interlocks, they are engineered for repeated high-load operation in busy production environments.",
  },
  {
    id: 8,
    name: "Planetary Mixer",
    category: "Mixers",
    image: "/8.webp",
    alt: "Large commercial planetary mixer with multiple attachments for bakery use",
    description:
      "Planetary mixers rotate the beater around the bowl while the bowl turns, achieving thorough blending for cakes, icings, fillings, and smaller dough batches. Interchangeable whips, paddles, and hooks adapt one machine to multiple recipes. Variable speed settings and stable bowl locking make this a versatile bench solution for bakeries producing a wide range of finished goods from a single mixing station.",
  },
  {
    id: 9,
    name: "Slow Speed Slicer",
    category: "Slicers",
    image: "/9.webp",
    alt: "Industrial slow speed bread slicer machine for commercial bakery operations",
    description:
      "Slow speed bread slicers cut loaves with controlled blade motion to achieve clean, even slices without crushing soft crumb structures. Designed for sandwich bread, tea rusks, and similar products, they prioritise slice consistency and product integrity over maximum line speed. Easy blade adjustment, safety guards, and sturdy frames support hygienic operation in packaging and retail preparation areas.",
  },
  {
    id: 10,
    name: "High Speed Slicer",
    category: "Slicers",
    image: "/10.webp",
    alt: "Commercial high speed automatic bread slicing machine in a production facility",
    description:
      "High speed slicers process large volumes of loaves per hour with automated feeding and precise blade arrays for uniform slice thickness. Built for industrial bakeries supplying retail and food service channels, they integrate with conveyor lines and packaging systems. Durable cutting assemblies and quick changeover features help maintain uptime during extended production runs.",
  },
  {
    id: 11,
    name: "Air Washer",
    category: "Utilities",
    image: "/11.webp",
    alt: "Industrial air washer and purification unit for commercial bakery environments",
    description:
      "Air washers filter and condition incoming air for bakery production areas, reducing dust, odours, and airborne contaminants that can affect product quality and equipment life. By improving ventilation hygiene, they support cleaner proofing and packing zones, especially in plants where flour dust control and temperature stability are operational priorities. Robust housings and accessible filter sections simplify routine maintenance.",
  },
  {
    id: 12,
    name: "Depanning Table",
    category: "Utilities",
    image: "/12.webp",
    alt: "Stainless steel commercial depanning table for removing bread from baking tins",
    description:
      "Depanning tables provide an ergonomic stainless work surface for removing baked goods from tins and trays immediately after the oven. Integrated vibration or tilt assists can speed release while protecting product shape. Sized for line-side placement, they improve operator efficiency and reduce handling damage during the critical hot-to-cool transfer stage of bread and rusk production.",
  },
  {
    id: 13,
    name: "Cooling Trolley",
    category: "Utilities",
    image: "/13.webp",
    alt: "Industrial bread cooling trolley with multiple wire shelves for bakery use",
    description:
      "Cooling trolleys hold racks of freshly baked product on ventilated shelves, allowing even air circulation before slicing or packaging. Mobile casters let operators move full loads through cooling corridors without repeated transfers. Wire or perforated shelving minimises moisture retention, helping achieve the correct crumb set and shelf life for bread, buns, and rusks.",
  },
  {
    id: 14,
    name: "Moulds Conveyor",
    category: "Conveyors",
    image: "/14.webp",
    alt: "Industrial moulds conveyor belt system for automated bakery production line",
    description:
      "Moulds conveyors transport filled baking moulds between filling, proofing, oven loading, and unloading stations in automated bread and rusk lines. Positive tracking keeps moulds aligned under depositors and ovens, reducing spills and misfeeds. Heavy-duty belts and adjustable speed drives synchronise with upstream mixers and downstream tunnel or rack oven systems.",
  },
  {
    id: 15,
    name: "Loading And Unloading Conveyor",
    category: "Conveyors",
    image: "/15.webp",
    alt: "Commercial loading and unloading conveyor system for industrial bakery automation",
    description:
      "Loading and unloading conveyors bridge oven infeed and outfeed points, moving racks, trays, or moulds without manual lifting. They align product presentation for operators or robotic pick points and smooth transitions between hot and cool zones. Variable speed control and sturdy guides accommodate different tray sizes across mixed-product bakery schedules.",
  },
  {
    id: 16,
    name: "Cotton Belt Conveyor",
    category: "Conveyors",
    image: "/16.webp",
    alt: "Cotton belt conveyor for delicate bakery products through baking and cooling lines",
    description:
      "Cotton belt conveyors use a soft, woven surface to carry delicate items such as biscuits, pastries, steamed buns, and light dough pieces through baking, cooling, and packaging stages. The gentle belt reduces marking and breakage compared with rigid metal alternatives. Easy cleaning and tension adjustment support food-safe handling in continuous production lines.",
  },
  {
    id: 17,
    name: "Moulds",
    category: "Accessories",
    image: "/17.webp",
    alt: "Set of industrial stainless steel bread baking moulds in various sizes",
    description:
      "Industrial baking moulds are precision-formed in stainless steel for repeatable loaf dimensions, crust development, and easy release. Available in multiple sizes and configurations to match product recipes from sandwich bread to rusk and bun lines. Durable construction withstands daily oven cycles, steam exposure, and plant washing without warping.",
  },
  {
    id: 18,
    name: "Lids",
    category: "Accessories",
    image: "/18.webp",
    alt: "Commercial stainless steel baking tin lids for industrial bread production",
    description:
      "Baking tin lids cap moulds during proofing and baking to control crust colour, moisture, and loaf shape. Matched to Rahul Engineering Works mould systems, they ensure consistent contact and heat transfer. Stainless construction resists deformation at production temperatures and simplifies cleaning between batches.",
  },
  {
    id: 19,
    name: "Trays",
    category: "Accessories",
    image: "/19.webp",
    alt: "Industrial perforated stainless steel baking trays for commercial bakery use",
    description:
      "Perforated stainless baking trays support even airflow under products in rack and swing tray ovens, improving bake uniformity for biscuits, rolls, and specialty items. Standardized sizes fit common rack dimensions for efficient loading. Perforation patterns balance strength with ventilation to reduce soggy bottoms and speed cooling.",
  },
  {
    id: 20,
    name: "Bun Rings",
    category: "Accessories",
    image: "/20.webp",
    alt: "Commercial stainless steel bun rings for shaping and baking buns in bulk",
    description:
      "Bun rings shape round buns and rolls to a consistent diameter before and during baking. Stainless rings release cleanly and tolerate repeated oven exposure. Used on trays or belts in high-volume bun lines, they help bakeries achieve uniform appearance for retail and institutional customers.",
  },
  {
    id: 21,
    name: "Contact Us",
    category: null,
    image: "/21.webp",
    alt: "Contact Us",
    description: null,
  },
];

export const PRODUCT_LAYOUT = [
  { id: 1, size: "medium" },
  { id: 2, size: "medium" },
  { id: 3, size: "medium" },
  { id: 4, size: "medium" },
  { id: 5, size: "medium" },
  { id: 6, size: "medium" },
  { id: 7, size: "medium" },
  { id: 8, size: "medium" },
  { id: 9, size: "medium" },
  { id: 10, size: "medium" },
  { id: 11, size: "medium" },
  { id: 12, size: "medium" },
  { id: 13, size: "medium" },
  { id: 14, size: "medium" },
  { id: 15, size: "medium" },
  { id: 16, size: "medium" },
  { id: 17, size: "medium" },
  { id: 18, size: "medium" },
  { id: 19, size: "medium" },
  { id: 20, size: "medium" },
  { id: 21, size: "medium" },
];

export const getProductDescription = (product) => {
  if (product.description) {
    return product.description;
  }

  const descriptionsByCategory = {
    Automation:
      "Integrated automation systems for efficient, consistent high-volume bakery production.",
    Ovens:
      "Built for consistent baking performance with efficient heat distribution and durable industrial-grade construction.",
    Mixers:
      "Engineered for smooth dough preparation with stable torque delivery and easy batch handling for continuous operations.",
    Slicers:
      "Precision slicing solutions designed for uniform cuts, high throughput, and low-maintenance daily production.",
    Utilities:
      "Essential utility systems that streamline workflow, improve hygiene, and support reliable plant-wide operations.",
    Conveyors:
      "Automated conveying equipment that improves line efficiency and ensures smooth product movement across stages.",
    Accessories:
      "High-quality bakery accessories that improve output consistency and support seamless production handling.",
  };

  return (
    descriptionsByCategory[product.category] ||
    "Industrial bakery equipment designed for reliable performance and long-term productivity."
  );
};

export const CATALOG_PRODUCTS = PRODUCTS.filter((product) => product.category);

export const PAGE_CONTENT_CLASS = "container mx-auto px-6 lg:px-12";
